import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { closePopup } from "./PopupReducer";

class ImagePopup extends React.Component<Props> {
    render() {
        const { isOpen, imageSrc, closePopup } = this.props;

        return (
            <Modal open={isOpen} onClose={closePopup}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        p: 2,
                        borderRadius: "12px",
                        boxShadow: 24,
                    }}
                >
                    <IconButton
                        onClick={closePopup}
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {imageSrc && (
                        <img
                            src={imageSrc}
                            alt="Carving"
                            className="galleryImgClass"
                            // style={{ maxWidth: "80vw", maxHeight: "80vh", borderRadius: "8px" }}
                        />
                    )}
                </Box>
            </Modal>
        );
    }
}

const mapStateToProps = (state: any) => ({
    isOpen: state.popup.isOpen,
    imageSrc: state.popup.imageSrc,
});

const mapDispatchToProps = { closePopup };

const connector = connect(mapStateToProps, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;
export default connector(ImagePopup);